import { render, staticRenderFns } from "./AssociarVendedor.vue?vue&type=template&id=2a755749"
import script from "./AssociarVendedor.vue?vue&type=script&lang=ts"
export * from "./AssociarVendedor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports